import React, { useState } from 'react';
import Button from './Button';
import SearchInput from './SearchInput';
import SectionLabel from './SectionLabel';
import Tooltip from './Tooltip';

/** Searchable, grouped glyph choices. Callers supply labels and rendered icons. */
export default function IconPicker({ groups, value, onChange, id, 'aria-label': ariaLabel = 'Choose icon' }) {
  const [query, setQuery] = useState('');
  const search = query.trim().toLowerCase();
  const filteredGroups = groups.map((group) => ({
    ...group,
    icons: group.icons.filter((icon) => `${icon.label} ${group.label}`.toLowerCase().includes(search)),
  })).filter((group) => group.icons.length);

  return (
    <div id={id} role="group" aria-label={ariaLabel} className="space-y-3">
      <SearchInput aria-label="Search icons" placeholder="Search icons" value={query} onChange={(event) => setQuery(event.target.value)} />
      <div className="max-h-64 overflow-y-auto rounded-bun border border-bun-line p-3">
        {filteredGroups.length ? filteredGroups.map((group) => (
          <div key={group.label} className="mb-4 last:mb-0">
            <SectionLabel as="h3" className="mb-2 leading-snug tracking-normal">{group.label}</SectionLabel>
            <div className="grid grid-cols-[repeat(auto-fill,minmax(44px,1fr))] gap-2">
              {group.icons.map((icon) => (
                <Tooltip key={icon.value} portal label={icon.label} anchorClassName="w-full">
                  <Button
                    variant="ghost"
                    iconOnly
                    selected={value === icon.value}
                    aria-label={icon.label}
                    className="h-11 w-full"
                    onClick={() => onChange(icon.value)}
                  >
                    {icon.icon}
                  </Button>
                </Tooltip>
              ))}
            </div>
          </div>
        )) : <p className="m-0 font-instrument text-bun-body text-bun-stone">No icons match your search.</p>}
      </div>
    </div>
  );
}
